import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	visibleItemsCount: {
		id: 'business-list.list-view.group-item.visible-items-count',
		defaultMessage: '{ visibleItems } of { totalGroupItems }',
		description:
			'Text of count of visible items to show when some are hidden by the show done items toggle',
	},
	addGroupItem: {
		id: 'business-list.list-view.group-item.add-group-item',
		defaultMessage: 'Add group item',
		description: 'A button to create child item/issue',
	},
	createIssue: {
		id: 'business-list.list-view.group-item.create-issue',
		defaultMessage: 'Create',
		description: 'Tooltip text to create subtask',
	},
});
